<template>
  <div class="page">
    <div class="header">
      <img class="logo" src="../assets/images/pc/header_logo.png" alt="" @click="goBack()" />
    </div>
    <div class="container">
      <div class="form">
        <div :style="{ display: isMobile ? '' : 'flex' }">
          <div class="form-row">
            <div class="label">*角色</div>
            <div class="value">
              <input class="id-input input" placeholder="請輸入角色ID（僅限數字）" type="tel" v-model="role_id" />
            </div>
          </div>
          <div class="form-row">
            <div class="label">*伺服器</div>
            <div class="value">
              <input class="id-input input" placeholder="請輸入伺服器ID（僅限數字）" type="tel" v-model="server_id" />
            </div>
          </div>

        </div>
        <div class="form-row">
          <div class="label">*儲值方式</div>
          <div class="value">
            <img class="checkbox" v-if="pay_type === 'mycard'" src="../assets/images/select_ok.png" />
            <img class="checkbox" v-if="pay_type === 'jiaopay_v3'" src="../assets/images/select_no.png" alt=""
              @click="onClickPayType('mycard')" />
            <img class="pay-icon" src="../assets/images/mycard_logo.png" alt="" />
            <!-- <img class="checkbox" v-if="pay_type === 'jiaopay_v3'" src="../assets/images/select_ok.png" alt="" />
            <img class="checkbox" v-if="pay_type === 'mycard'" src="../assets/images/select_no.png" alt=""
              @click="onClickPayType('jiaopay_v3')" />
            <img class="pay-icon" src="../assets/images/jiaopay_logo.png" alt="" /> -->
          </div>
          <!-- <div class="info-btn" @click="onConfirmInfo()">Confirm</div> -->
        </div>
        <div class="items-row">
          <div class="purchase">*選擇代金券金額：</div>
          <div class="items">
            <template v-for="(item, index) in itemUrls">
              <div class="item-box" @click="onClickItem(index)">
                <img class="item" v-if="index === itemIndex"
                  :src="require(`../assets/images/common/${item}_select.png`)" alt="" />
                <img class="item" v-else :src="require(`../assets/images/common/${item}.png`)" alt="" />
                <img v-if="item === 3290" class="discount" src="../assets/images/common/percent_4.png" alt="">
                <img v-if="item === 1060 || item === 1690" class="discount" src="../assets/images/common/percent_5.png"
                  alt="">
              </div>
            </template>
          </div>
        </div>
        <div class="btn-row">
          <img class="confirm-btn" @click="onConfirmPay" :class="!disableYes ? '' : 'disabled-btn'"
            src="../assets/images/common/button_recharge.png" alt="" />
        </div>
      </div>
      <div class="rule-row">
        <span class="title">*說明及注意事項：<br /></span>
        <span class="content">
          1. 1代鈔=1TWD; <br />
          2.
          如需查看您的角色ID，请進入遊戲并點擊介面左上角的頭像，即可看到對應的角色ID;<br />
          3.
          於當前網頁完成儲值後，可登入遊戲，通過遊戲內郵件確認儲值完成情況，
          <span v-if="isMobile"><br />&nbsp;&nbsp;&nbsp;&nbsp;</span>並點擊介面左上角頭像確認當前代金券餘額;<br />
          4. 代金券可直接用於購買遊戲內的元寶、禮包、月卡等商品；<br />
          5.
          於當前網頁完成儲值後，需在遊戲內消耗代金券，才可參與遊戲內的儲值活動
          <span v-if="isMobile"><br />&nbsp;&nbsp;&nbsp;&nbsp;</span>並獲得相應VIP特權經驗;<br />
          6.
          如果於當前網頁完成儲值24小時以後還未收到發放的代金券，請回報至客服郵箱
          <span v-if="isMobile">&nbsp;&nbsp;&nbsp;&nbsp;</span>cs_as@flame-games.com； </span><br />
      </div>
      <div class="footer-row">
        <img class="icon" src="../assets/images/pc/FlameGames1.png" alt="" />
        <div class="content">&copy; 2023 Flamegames. All Rights Reserved</div>
      </div>
    </div>

    <div class="dialog" v-if="isShowConfirmInfo">
      <div class="container">
        <div class="tips">為減少不必要的損失，請您確認以下儲值資訊無誤</div>
        <div class="content">
          <div class="row">
            <span>&nbsp;&nbsp;{{ `江湖風雲傳` }}</span>
          </div>
          <div class="row">
            <span>&nbsp;&nbsp;{{ roleInfo.role_id }}</span>
          </div>
          <div class="row">
            <span>&nbsp;&nbsp;{{ roleInfo.server_name }}</span>
          </div>
          <div class="row">
            <span>&nbsp;&nbsp;{{ roleInfo.role_name }}</span>
          </div>
          <div class="row">
            <span>&nbsp;&nbsp;{{ `${itemUrls[itemIndex]}TWD` }}</span>
          </div>
        </div>
        <div class="btns">
          <img class="btn" src="../assets/images/common/unfollow.png" @click="toggleConfirmInfo(false)" />
          <img class="btn" :class="disableYes ? 'disabled-yes' : ''" src="../assets/images/common/sure.png"
            @click="onYes" />
        </div>
      </div>
    </div>
    <Toast v-if="msg" :type="msgType" :msg="msg" @close="() => this.$store.commit('setMsg', '')"></Toast>
    <div class="loading" v-if="loading">
      <div class="loading-tip">
        <div class="loading-dialog">
          <div class="loading-content">正在跳轉支付頁面中，請耐心等待</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getItems, getUserInfo, pay } from '@/global/api/api.js'
import { getTs, getSign, generateUUID, throttle } from '@/global/js/utils.js'
import Toast from '@/components/Dialog.vue'

const itemUrls = [10, 19, 33, 65, 135, 160, 270, 530, 690, 1060, 1690, 3290]
//const itemUrls = [33, 65, 160, 270, 530, 690, 1060, 1690, 3290]
const PayType = {
  MyCard: 'mycard',
  JiaoPay: 'jiaopay_v3'
}
const PayInfo = {
  return_url: 'https://pixeltoj.hookylin.com/#/purchase'
  //return_url: 'https://fe-inet.zkyouxi.com/game-official-fe-hk/#/purchase'
  //return_url: 'http://172.16.0.244:8080/#/purchase'
}
const NotFound = {
  server_name: '你的覅u和',
  role_name: '你的覅u和 ',
  role_level: '你的覅u和',
  os: '你的覅u和'
}
export default {
  data() {
    return {
      items: [],
      itemIndex: 0,
      itemUrls: itemUrls,

      isShowConfirmInfo: false,
      disableYes: true, // 禁用确认信息里的Yes按钮，当禁用时，角色信息为空
      hasConfirmInfo: false,

      gameInfo: {
        game_id: 3,
        game_channel_id: 11,
        ad_id: 23013
      },

      role_id: '',
      server_id: '',
      roleInfo: NotFound,
      pay_type: PayType.MyCard,
      //       msg: `完成交易，
      // 前往遊戲查收代鈔！`,
      msgType: 'confirm',
      loading: false
    }
  },
  components: { Toast },
  methods: {
    isMobilePlat() {
      const width = document.body.clientWidth
      if (width <= 768) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    onClickItem(index) {
      this.itemIndex = index
    },
    toggleConfirmInfo(val) {
      this.isShowConfirmInfo = val
    },
    onYes() {
      if (this.disableYes) {
        return
      }
      this.hasConfirmInfo = true
      this.toggleConfirmInfo(false)
      this.pay()
    },
    async onConfirmInfo() {
      if (!this.role_id) {
        this.$store.commit('setMsg', '請输入角色ID')
        return
      }
      this.hasConfirmInfo = false
      this.disableYes = true
      let params = {
        ...this.gameInfo,
        role_id: this.role_id,
        trace_id: generateUUID(),
        ts: getTs()
      }
      if (this.server_id) {
        params.server_id = this.server_id
      }
      const sign = getSign(params)
      params.sign = sign
      getUserInfo(params)
        .then((res) => {
          this.disableYes = false
          this.roleInfo = res.data
          this.toggleConfirmInfo(true)
        })
        .catch((err) => {
          this.$store.commit('setMsg', '請確認角色ID是否正確')
          this.disableYes = false
          // this.roleInfo = NotFound
          // this.toggleConfirmInfo(true)
        })
    },
    async pay() {
      // console.log(!this.hasConfirmInfo || this.disableYes)
      // if (!this.hasConfirmInfo || this.disableYes) {
      //   return
      // }
      this.loading = true
      const item = this.items[this.itemIndex]
      const { user_id, role_id, role_name, server_id } = this.roleInfo
      let params = {
        ...this.gameInfo,
        user_id: user_id,
        role_id: role_id,
        role_name: role_name,
        server_id: server_id,
        product_id: item.product_id,
        money: item.sell_price,
        pay_type: this.pay_type,
        currency: 'TWD',
        trace_id: generateUUID(),
        ts: getTs()
      }
      params['pay_info'] = PayInfo
      const sign = getSign(params)
      params.sign = sign
      const res = await pay(params)
      this.loading = false
      if (res.ret === 0) {
        const url = res.data.approve_url
        window.location.href = url
      } else {
        this.$store.commit('setMsg', 'Server Error')
      }
    },
    onConfirmPay: throttle(function () {
      if (this.disableYes) return
      this.onConfirmInfo()
      //this.pay()
    }, 500),
    goBack() {
      this.$router.push({
        path: '/'
      })
    },
    onClickPayType(type) {
      this.pay_type = type
    }
  },
  async created() {
    this.isMobilePlat()
    const params = {
      ...this.gameInfo,
      trace_id: generateUUID(),
      ts: getTs()
    }
    const sign = getSign(params)
    params.sign = sign
    await getItems(params)
      .then((res) => {
        if (res.ret === 0) {
          this.items = res.data.sort((a, b) => a.price - b.price)
          console.log('items', this.items)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  computed: {
    msg() {
      return this.$store.state.msg
    }
  },
  watch: {
    role_id(val) {
      this.disableYes = val ? false : true
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: #000;
}

/* PC端 */
@media screen and (min-width: 769px) {
  @import '../assets/css/pay_pc.less';
}

/* 移动端  */
@media screen and (max-width: 769px) {
  @import '../assets/css/pay_m.less';
}
</style>
